import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import { EditScannerMutation as EditScanner, EditScannerInput } from '__generated__/graphql';

import { useNotifier } from '../../../common/Notifications/NotificationProvider';
import EditScannerMutation from './EditScannerMutation';
import useScroll from '../../../common/useScroll';

interface UseEditScannerMutationProps {
  input: EditScannerInput,
  onSuccess?: (ticket: EditScanner['editScanner']) => void;
}

const useEditScannerMutation = ({
  input, onSuccess,
}: UseEditScannerMutationProps) => {
  const { t } = useTranslation();
  const notifier = useNotifier();
  const { scrollToIfInvisible } = useScroll();

  return useMutation(
    EditScannerMutation,
    {
      variables: {
        input,
      },
      onCompleted: ({ editScanner: scanner }) => {
        notifier.success(t('notifications.scanner_saved'));

        onSuccess?.(scanner);
      },
      onError: () => {
        scrollToIfInvisible(`ScannerCard_${input.id}`);
      },
    },
  );
};

export default useEditScannerMutation;
